//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tHallPolicyFileId } from "@/api/portrayal/policy";
import { handleDownload } from "@/api/managementCenter/otherApi";
var timer = null; //定义初始值

export default {
  name: "fileDetail",
  components: {},
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      resData: {}
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.getFileInfo();
  },
  methods: {
    getFileInfo: function getFileInfo() {
      var _this = this;

      this.loading = true;
      tHallPolicyFileId(this.$route.query.id, this.$route.query.fileId || "").then(function (_ref) {
        var data = _ref.data;
        _this.loading = false;

        if (data.code == 0) {
          _this.resData = data.data || {};
        } else {
          _this.$message.error(data.msg || "获取校内公文失败！");
        }
      }).catch(function (err) {
        _this.loading = false;

        _this.$message.error("服务器异常!");
      });
    },
    goTop: function goTop() {
      timer = setInterval(function () {
        var osTop = document.documentElement.scrollTop || document.body.scrollTop;
        var ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;

        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
    downLoadFile: function downLoadFile(item) {
      var _this2 = this;

      this.$DownLoad(handleDownload(item.fileId), null, function (res) {
        if (res.status == 200) {} else {
          _this2.$alert("下载出错,请稍后重试", "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      }, function (error) {
        _this2.$alert(error, "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      });
    }
  },
  destroyed: function destroyed() {},
  watch: {},
  filters: {}
};